import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Environment } from '../environment';
import { ProductName } from '../graphql-client/graphql';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json'
  }),
  responseType: 'text' as 'text'
};

interface EmailLocation {
  name: string;
  address1: string;
  address2: string;
  city: string;
  state: string;
  zip: string;
  phone: string;
  distance: string;
}

interface EmailRequest {
  email: string;
  product: ProductName;
  pLocation: Array<EmailLocation>;
}

@Injectable({
  providedIn: 'root'
})
export class EmailService {
  constructor(private http: HttpClient, private env: Environment) {}

  sendEmail(request: EmailRequest) {
    return this.http.post(this.env.emailApi, request, httpOptions);
  }
}
